import React from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (localStorage.getItem("ibiza_admin_token")) {
      navigate("/admin", { replace: true });
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", {
        username: username.trim().toLowerCase(),
        password,
      });
      localStorage.setItem("ibiza_admin_token", r.data.access_token);
      localStorage.setItem("ibiza_admin_username", r.data.username);
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen grid place-items-center bg-[#0A0B10] grain relative px-6"
      data-testid="admin-login-page"
    >
      <div className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: "url('https://images.pexels.com/photos/33575697/pexels-photo-33575697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B10] via-[#0A0B10]/90 to-[#0A0B10]/60" />

      <form
        onSubmit={submit}
        className="relative glass rounded-2xl p-10 w-full max-w-md"
        data-testid="admin-login-form"
      >
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-full border border-[#C5A059] grid place-items-center text-[#C5A059]">
            <Lock size={22} />
          </div>
        </div>
        <p className="overline text-center mb-3">Admin Access</p>
        <h1 className="font-serif-display text-3xl text-center">Ibiza Poolside Portal</h1>
        <p className="text-center text-[#A1A4B5] text-sm mt-2">
          Sign in to manage bookings, photos & content.
        </p>

        <div className="mt-8 space-y-4">
          <div>
            <Label className="text-[#A1A4B5] text-xs uppercase tracking-[0.18em]">Username</Label>
            <Input
              data-testid="admin-username-input"
              type="text"
              required
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-2 bg-[#13151D] border-[var(--border)]"
              placeholder="mikeey38"
            />
          </div>
          <div>
            <Label className="text-[#A1A4B5] text-xs uppercase tracking-[0.18em]">Password</Label>
            <Input
              data-testid="admin-password-input"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-[#13151D] border-[var(--border)]"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="gold-btn rounded-full w-full py-6"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </div>
      </form>
    </div>
  );
}
